import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface INoDataInList {
  heading?: string;
  description?: string;
  className?: string;
}

export const NoDataInList = ({
  heading,
  description,
  className,
}: INoDataInList) => {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        py: 4,
        textAlign: 'center',
      }}
    >
      <Box>
        {heading && (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: 'text.secondary',
            }}
          >
            {heading}
          </Typography>
        )}
        {description && (
          <Typography
            variant="caption"
            sx={{
              color: 'text.disabled',
              mt: 0.5,
              display: 'block',
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default NoDataInList;
